<template>
  <div/>
</template>

<script>
  import G6Editor from 'antv/g6-editor'
  export default {
    data () {
      return {
        selectedModel: {},
        curZoom: 1,
        editor: null,
        page: null,
        arrowList: [{
          name: 'arrow_ver',
          img: require('@/assets/image/arrow_ver.svg')
        }, {
          name: 'arrow_down',
          img: require('@/assets/image/arrow_down.svg')
        }, {
          name: 'arrow_up',
          img: require('@/assets/image/arrow_up.svg')
        }, {
          name: 'arrow_left',
          img: require('@/assets/image/arrow_left.svg')
        }, {
          name: 'arrow_right',
          img: require('@/assets/image/arrow_right.svg')
        }, {
          name: 'arrow_hor',
          img: require('@/assets/image/arrow_hor.svg')
        }]
      }
    },
    methods: {
      registerEvent () {
        const that = this
        this.page.on('click', ev => {
          if (!this.showTools) {
            if (ev.item && ev.item.model && ev.item.model.url) {
              window.open(ev.item.model.url + this.getFormatTime(), '_blank')
            }
          }
          if (!ev.item) this.nodeList = []
        })
        this.page.on('afteritemselected', ev => {
          if (this.showTools) {
            if (ev.item.isNode) this.chooseLink = ev.item.model.appName ? ev.item.model.appName : this.$t('networkTopology.choose')
          }
        })
        this.page.on('hovernode:beforeshowanchor', ev => {
          ev.cancel = !this.showTools // 若设置为 true 则取消显示锚点
        })
        this.page.on('dragedge:beforeshowanchor', ev => {
          ev.cancel = !this.showTools // 若设置为 true 则取消显示要去连接的锚点
        })
        this.page.on('hoveranchor:beforeaddedge', ev => {
          ev.cancel = !this.showTools // 若设置为 true 则取消显示要去连接的锚点
        })
        this.page.on('afteritemselected', ev => {
          that.selectedModel = ev.item.getModel()
          that.currentShape = ''
          if (ev.item.isNode) {
            if (that.selectedModel.shape.indexOf('line') >= 0) {
              that.currentShape = 'line'
              that.nodeLength = that.selectedModel.shape.indexOf('hor') >= 0
                ? that.selectedModel.size.split('*')[0]
                : that.selectedModel.size.split('*')[1]
            } else if (that.selectedModel.shape.indexOf('text') >= 0) {
              that.currentShape = 'text'
            } else if (that.selectedModel.shape.indexOf('arrow') >= 0) {
              that.currentShape = 'arrow'
            } else {
              that.currentShape = 'element'
            }
            that.nodeWidth = that.selectedModel.size.split('*')[0]
            that.nodeHeight = that.selectedModel.size.split('*')[1]
            that.nodeName = that.selectedModel.label
            that.nodeFontSize = that.selectedModel.fontSize ? that.selectedModel.fontSize : 20
          } else if (ev.item.isGroup) {
            that.groupLineWidth = that.selectedModel.lineWidth
            that.groupLineColor = that.selectedModel.color
          }
          this.nodeList.push(this.selectedModel)
        })
      },
      registerGroup () {
        G6Editor.Flow.registerGroup('customGroup', {
          draw (item) {
            const group = item.getGraphicGroup()
            const childrenBox = item.getChildrenBBox()
            const model = item.getModel()
            childrenBox.x -= 10
            childrenBox.y -= 10
            childrenBox.width += 20
            childrenBox.height += 20
            model.color = model.color ? model.color : 'dedede'
            model.lineWidth = model.lineWidth ? model.lineWidth : '1'
            group.addShape('rect', {
              attrs: {
                ...childrenBox,
                stroke: 'rgba(255,255,255,0)',
                lineWidth: 20
              }
            })
            return group.addShape('rect', {
              attrs: {
                ...childrenBox,
                lineWidth: Number(model.lineWidth),
                stroke: model.color
              }
            })
          }
        })
      },
      registerNode () {
        this.arrowList.map((_item, index) => {
          let x = -25
          let y = -35
          G6Editor.Flow.registerNode(_item.name, {
            draw (item) {
              const group = item.getGraphicGroup()
              const model = item.getModel()
              return group.addShape('image', {
                attrs: {
                  x: index < 3 ? x : y,
                  y: index < 3 ? y : x,
                  width: Number(model.size.split('*')[0]),
                  height: Number(model.size.split('*')[1]),
                  img: _item.img
                }
              })
            },
            anchor: []
          })
        })
        G6Editor.Flow.registerNode('line_hor', {
          draw (item) {
            const group = item.getGraphicGroup()
            const model = item.getModel()
            group.addShape('rect', {
              attrs: {
                x: -35,
                y: -10,
                fill: 'rgba(255,255,255,0)',
                width: Number(model.size.split('*')[0]),
                height: 20
              }
            })
            return group.addShape('rect', {
              attrs: {
                x: -35,
                y: 0,
                stroke: '#000',
                width: Number(model.size.split('*')[0]),
                height: 1,
                lineWidth: 0.3
              }
            })
          },
          anchor: []
        })
        G6Editor.Flow.registerNode('line_ver', {
          draw (item) {
            const group = item.getGraphicGroup()
            const model = item.getModel()
            group.addShape('rect', {
              attrs: {
                x: -10,
                y: -35,
                fill: 'rgba(255,255,255,0)',
                height: Number(model.size.split('*')[1]),
                width: 20
              }
            })
            return group.addShape('rect', {
              attrs: {
                x: 0,
                y: -35,
                stroke: '#000',
                width: 1,
                height: Number(model.size.split('*')[1]),
                lineWidth: 0.3
              }
            })
          },
          anchor: []
        })
        G6Editor.Flow.registerNode('custom_text', {
          draw (item) {
            const group = item.getGraphicGroup()
            const model = item.getModel()
            model.fontSize = model.fontSize ? model.fontSize : 20
            return group.addShape('text', {
              attrs: {
                x: 0,
                y: 0,
                fill: '#333',
                fontSize: Number(model.fontSize),
                textAlign: 'center',
                textBaseline: 'middle',
                text: model.label
              }
            })
          },
          anchor: []
        })
      },
      registerCommand () {
        const that = this
        G6Editor.Command.registerCommand('customAddGroup', {
          enable () {
            return true
          },
          execute () {
            if (that.nodeList.length > 0) {
              that.page.add('group', {
                x: 50,
                y: 50,
                shape: 'customGroup'
              })
              let lastGroup = that.page.getGroups()[that.page.getGroups().length - 1].id
              that.nodeList.map(item => {
                that.page.update(item.id, {
                  parent: lastGroup
                })
              })
            }
          }
        })
      },
      savePage () {
        let saveObj = this.page.save()
        this.saveTopoInfo(saveObj)
      },
      initEditor (draggable) {
        const height = window.innerHeight - 170
        this.editor = new G6Editor()
        const minimap = new G6Editor.Minimap({
          container: 'minimap',
          height: 130,
          width: 198
        })
        const itempannel = new G6Editor.Itempannel({
          container: 'itempannel'
        })
        const contextmenu = new G6Editor.Contextmenu({
          container: 'contextmenu'
        })
        const detailpannel = new G6Editor.Detailpannel({
          container: 'detailpannel'
        })
        const toolbar = new G6Editor.Toolbar({
          container: 'toolbar'
        })
        let editorConfig = {
          graph: {
            container: 'page',
            height,
            fitView: 'autoZoom'
          },
          align: {
            grid: true
          }
        }
        if (!draggable) {
          editorConfig.graph.modes = {
            default: ['panCanvas']
          }
        }
        this.page = new G6Editor.Flow({ ...editorConfig })
        this.page.changeAddEdgeModel({
          shape: 'flow-polyline-round'
        })
        this.registerNode()
        this.registerGroup()
        this.registerCommand()
        this.registerEvent()
        this.editor.add(minimap)
        this.editor.add(itempannel)
        this.editor.add(contextmenu)
        this.editor.add(detailpannel)
        this.editor.add(toolbar)
        this.editor.add(this.page)
      },
      changeZoom (zoom) {
        const page = this.page
        page.zoom(Number(zoom))
      },
      changeGrid () {
        this.showGrid = !this.showGrid
      }
    },
    mounted () {}
  }
</script>
<style>
    
</style>
